/* tslint:disable */

declare var Object: any;
export interface ConfigurationInterface {
  "type": string;
  "name": string;
  "value"?: string;
  "hash"?: boolean;
  "dateCreated": Date;
  "lastModified": Date;
  "order": number;
  "id"?: number;
}

export class Configuration implements ConfigurationInterface {
  "type": string;
  "name": string;
  "value": string;
  "hash": boolean;
  "dateCreated": Date;
  "lastModified": Date;
  "order": number;
  "id": number;
  constructor(data?: ConfigurationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Configuration`.
   */
  public static getModelName() {
    return "Configuration";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Configuration for dynamic purposes.
  **/
  public static factory(data: ConfigurationInterface): Configuration{
    return new Configuration(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Configuration',
      plural: 'Configurations',
      path: 'Configurations',
      idName: 'id',
      properties: {
        "type": {
          name: 'type',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
        "hash": {
          name: 'hash',
          type: 'boolean',
          default: false
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastModified": {
          name: 'lastModified',
          type: 'Date'
        },
        "order": {
          name: 'order',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
